import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

export const Wrapper = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  flex-shrink: 0;
`;

/*
 * GAP (flagged in KgPipelineStatus.styleMap.md): no design token exists for a
 * pill text cap; 18rem chosen so a long error_message truncates instead of
 * pushing the filter pills off the bar. Shared by the failed and unavailable pills.
 */
export const PillLabel = styled.span`
  display: inline-block;
  max-width: 18rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SpinnerSlot = styled.span`
  display: inline-flex;
  align-items: center;
`;
